export default ".not-found h1 {\n  text-align: center;\n  font-size: 10.6666666667rem;\n  line-height: 14.5rem;\n}\n.not-found h2 {\n  text-align: center;\n}";